const replaceDiacretics = (text: string) => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
};

export const normalizeText = (text: string) => {
  return replaceDiacretics(text).toLowerCase();
};
